import Carta from "@contextualize/carta";

export interface FavoriteSchema {
  key: string;
  [key: string]: any; // Allow any additional metadata
}

export interface PreferencesData {
  favorites?: FavoriteSchema[];
}

export interface PreferencesResponse {
  userId: string;
  service: string;
  data: PreferencesData;
  updatedAt: string | null;
}

export async function getPreferences(
  carta: Carta,
  service: string
): Promise<PreferencesData> {
  try {
    // Use carta.service.utilize() to call the user-preferences service
    const preferencesService = carta.service.utilize("carta", "user-preferences");
    const response = await preferencesService.get(`/preferences/${service}`);

    if (!response.ok) {
      throw new Error(`Failed to fetch preferences: ${response.statusText}`);
    }

    const result = (await response.json()) as PreferencesResponse;
    return result.data || {};
  } catch (error) {
    console.error("Error fetching preferences:", error);
    return {};
  }
}

export async function savePreferences(
  carta: Carta,
  service: string,
  data: PreferencesData
): Promise<void> {
  try {
    // Use carta.service.utilize() to call the user-preferences service
    const preferencesService = carta.service.utilize("carta", "user-preferences");
    const response = await preferencesService.put(`/preferences/${service}`, {
      json: { data },
    });

    if (!response.ok) {
      throw new Error(`Failed to save preferences: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error saving preferences:", error);
  }
}
